import { render, staticRenderFns } from "./NewDocumentEditor.vue?vue&type=template&id=7af47576&scoped=true&"
import script from "./NewDocumentEditor.vue?vue&type=script&lang=ts&"
export * from "./NewDocumentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./NewDocumentEditor.vue?vue&type=style&index=0&id=7af47576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af47576",
  null
  
)

export default component.exports